import { render, staticRenderFns } from "./advertisementdetail.vue?vue&type=template&id=4f849113&scoped=true&"
import script from "./advertisementdetail.vue?vue&type=script&lang=js&"
export * from "./advertisementdetail.vue?vue&type=script&lang=js&"
import style0 from "./advertisementdetail.vue?vue&type=style&index=0&id=4f849113&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f849113",
  null
  
)

component.options.__file = "advertisementdetail.vue"
export default component.exports